// data/doctors.js

import Shivaleela from "../Images/Shivaleela_2.png";
import Ignatius from "../Images/Ignatious.png";

const doctors = [
  {
    id: 1,
    name: "Dr. Shivaleela Dhotrad",
    specialty: "Dental Surgeon",
    image: Shivaleela,
    linkedin:
      "https://www.linkedin.com/in/dhotrad-s-sunny-dental-clinics-639b701b2/?originalSubdomain=in",
  },
  {
    id: 2,
    name: "Dr. Ignatius Fernandes",
    specialty: "Orthodontist",
    image: Ignatius,
    linkedin:
      "https://www.linkedin.com/in/dhotrad-s-sunny-dental-clinics-639b701b2/?originalSubdomain=in",
  },
];

export default doctors;
